import type { FilterItem } from "@repo/models";

import type { ISegment } from "../helpers/segmentFilterHook";
import type { BranchFilterItem, MarketFilterItem } from "../models/filterItem";

import { BaseController } from "./baseController";

const controller = "GridFilters";

export interface StateFilterItem extends FilterItem {
	code: string;
}

/** Arrow properties rather than methods so they can be passed as query functions without binding. */
export class GridFiltersController extends BaseController {
	static Get = BaseController.GetFn(controller);

	static GetFilterItems = <T extends FilterItem = FilterItem>(action: string, filters?: ISegment) =>
		GridFiltersController.Get<T[]>(action, filters);

	static getBrands = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetBrandsDyn", filters);

	static getChannels = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetChannelsDyn", filters);

	static getMarketers = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetMarketersDyn", filters);

	static getStates = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetStatesDyn", filters);

	static getAllStates = () => GridFiltersController.GetFilterItems<StateFilterItem>("GetAllStatesDyn");

	static getBranches = (filters?: ISegment) =>
		GridFiltersController.GetFilterItems<BranchFilterItem>("GetBranchesDyn", filters);

	static getReps = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetRepsDyn", filters);

	static getMachines = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetMachinesDyn", filters);

	static getCompanies = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetCompaniesDyn", filters);

	static getDivisions = (filters?: ISegment) =>
		GridFiltersController.GetFilterItems("GetCompanyDivisionsDyn", filters);

	static getRegions = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetCompanyRegionsDyn", filters);

	static getMarkets = (filters?: ISegment) =>
		GridFiltersController.GetFilterItems<MarketFilterItem>("GetCompanyMarketsDyn", filters);

	static getManagementAreas = (filters?: ISegment) =>
		GridFiltersController.GetFilterItems<MarketFilterItem>("GetCompanyManagementAreasDyn", filters);

	static getOffices = (filters?: ISegment) => GridFiltersController.GetFilterItems("GetOfficesDyn", filters);

	static getLocationStatuses = (filters?: ISegment) =>
		GridFiltersController.GetFilterItems("GetLocationStatuses", filters);

	static getUsers = (assignedOnly?: boolean) =>
		GridFiltersController.Get<FilterItem[]>("GetUsersDyn", { assignedOnly });
}
